//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import InlinePrompt from "@Shared/components/general/inline-prompt";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ESignDocumentsOnTheGoPage",
  components: {
    SimpleButton,
    InlinePrompt
  },
  mixins: [validationMixin],
  props: {
    currentTemplateData: {
      type: Object,
      required: true
    },
    uploadingDocument: {
      type: Boolean,
      default: false
    }
  },
  validations: {
    currentTemplateData: {
      files: {
        required
      }
    }
  },
  data() {
    return {
      fileNameMaxLength: 35
    };
  },
  computed: {
    isValid() {
      return !this.$v.currentTemplateData.files.$invalid;
    },
    table() {
      return {
        columns: ["name", "actions"],
        options: {
          skin: "table table-hover",
          filterable: false,
          sortable: [],
          perPage: 999999,
          headings: {
            name: this.$t("global.words.name"),
            actions: this.$t("global.words.actions")
          },
          showChildRowToggler: false,
          tabbable: false,
          columnsClasses: {
            name: "w-90",
            actions: "w-10"
          },
          texts: {
            noResults: this.$t("e-sign-package.messages.emptyDocsOnTemplate")
          }
        }
      };
    }
  },
  watch: {
    isValid: {
      handler(value) {
        this.$emit("valid", value);
      },
      immediate: true
    }
  },
  methods: {
    handleDeleteDocument(documentId) {
      this.$emit("delete-template-document", documentId);
    },
    async handleDocumentSelected(event) {
      const files = event.target.files;
      if (!(files != null && files.length)) return;
      const fileSelected = files[0];
      this.$emit("select-template-document", fileSelected);
      this.$refs.fileInput.value = "";
    }
  }
});